
<!-- <picture 
	*rxIf="media.bundle === 'image'"
	[media]="media"
	[loading]="loading" 
	type="screen"
></picture>

<lib-video 
	*rxIf="media.bundle === 'video'"
	[playOnLoad]="true"
	[media]="media"
></lib-video>
 -->


<div class="media-wrapper" [@fadeIn]="loaded() ? 'visible' : 'hidden' " >
  <ng-container [ngSwitch]="type">
    <img
      *ngSwitchCase="'image'"
      [src]="src"
      [srcset]="srcset"
      [sizes]="sizes"
      [alt]="alt"
      (load)="onLoad()"
      (error)="onError($event)"
    />

    <video
      *ngSwitchCase="'video'"
      autoplay
      [muted]="true"
      [loop]="true" 
      playsinline 
      (loadeddata)="onLoad()"
      (error)="onError($event)"
    >
    	<source [src]="getMp(src)" type="video/mp4" />
    	<source [src]="src" type="video/webm" />
    </video>
  </ng-container>
</div>

<div class="loader" *ngIf="!loaded()">
	<span class="spinner"></span>
</div>